import { useMutation, useQuery } from "@tanstack/react-query";
import { APIErrorResponse } from "src/types/generic";
import apiCloudClient from "./apiCloudClient";
import { ISalesSummaryReport } from "src/types/reports";
import apiFastifyClient from "./apiFastifyCloud";
import { QueryParamValue, toQueryString } from "src/utils";

interface IParams {
  startDate?: string | number;
  endDate?: string | number;
  locations?: string[];
  userId?: string;
  serviceType?: string;
  page?: number;
  limit?: number;
  cities?: string[];
  locationType?:string
}

export const useGetSalesSummary = (params: IParams) =>
  useQuery<IParams, any, { data: ISalesSummaryReport }>({
    queryKey: [
      "get-sales-summary",
      params.startDate,
      params.endDate,
      params.locations,
      params.serviceType,
      params.userId,
      params.cities,
      params.locationType
    ],
    queryFn: async () => {
      const queryString = toQueryString(
        params as Record<string, QueryParamValue>
      );
      return apiFastifyClient.get(
        `/v1/transactions/reports/sales-summary?${queryString}`
      );
    },
    enabled: !!params.startDate && !!params.endDate,
    gcTime: 1 * 60 * 60 * 1000, // 1 Hour
  });

export const useGetSalesTransactions = (params: IParams) =>
  useQuery<IParams, any, { data: any; meta: { total: number } }>({
    queryKey: [
      "get-sales-transactions-details",
      params.page,
      params.limit,
      params.startDate,
      params.endDate,
      params.locations,
      params.serviceType,
      params.userId,
      params.cities,
      params.locationType
    ],
    queryFn: async () => {
      const queryString = toQueryString(
        params as Record<string, QueryParamValue>
      );
      return apiFastifyClient.get(
        `/v1/transactions/reports/sales-transactions?${queryString}`
      );
    },
    enabled: !!params.startDate && !!params.endDate,
    gcTime: 1 * 60 * 60 * 1000, // 1 Hour
  });

export const useExportSalesTransactions = (params: IParams) =>
  useQuery<IParams, any, any>({
    queryKey: [
      "export-sales-transactions-details",
      params.startDate,
      params.endDate,
      params.locations,
      params.serviceType,
      params.userId,
    ],
    queryFn: async () => {
      const queryString = toQueryString(
        params as Record<string, QueryParamValue>
      );
      return apiFastifyClient.get(
        `/v1/transactions/reports/sales-transactions/exports?${queryString}`
      );
    },
    enabled: false,
  });

interface IBody {
  data: {
    startDate?: string;
    endDate?: string;
    locations?: string[];
    services?: string[];
  };
}

export const useGetSalesSummaryMutation = () =>
  useMutation<any, APIErrorResponse, IBody>({
    mutationFn: async (data) => {
      return apiCloudClient.post(`/getSalesSummaryRequest`, data);
    },
  });

export const useExportKafdReport = (params: IParams) =>
  useQuery<IParams, any, any>({
    queryKey: ["export-kafd-report", params.startDate, params.endDate],
    queryFn: async () => {
      const queryString = toQueryString(
        params as Record<string, QueryParamValue>
      );
      return apiFastifyClient.get(
        `/v1/transactions/reports/kafd-sales-transactions/exports?${queryString}`
      );
    },
    enabled: false,
  });
